import { useContext, useEffect, useRef, useState } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import useRecruiterDashboard from './useRecruiterDashboard';

const RecruiterDashboardAccordianItem = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const [expanded, setExpanded] = useState(true);
    const { setStateValue } = useRecruiterDashboard();
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Update individual accordion state based on the global accordion state
        setExpanded(state.data.accordionState === 'EXPANDED');
    }, [state.data.accordionState]);

    return (
        <div className="accordion-item h-100" ref={divRef}>
            <h2 className="accordion-header" id={`panelsStayOpen-${props.reportKey}`} onClick={() => {setStateValue(props.reportKey.toLowerCase()+'_isOpen' , (!expanded).toString()); setExpanded(!expanded);}}>
                <button
                    className={`accordion-button ${expanded ? 'collapsed' : ''}`}
                    type="button"
                    aria-expanded={expanded}
                    aria-controls={`${props.reportKey}`}>
                    {props.title}
                    <i className="bi bi-info-circle-fill defaultTooltip font-16 ms-2" data-bs-toggle= 'tooltip' title={props.tooltip}></i>
                </button>
            </h2>
            <div
                id={`item-${props.reportKey}`}
                className={`accordion-collapse collapse ${expanded ? 'show' : ''}`}
                aria-labelledby={`item-${props.reportKey}`}>
                <div className="accordion-body">
                    
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div id="stdonboardgraph">
                                <div className="d-block text-center">{props.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecruiterDashboardAccordianItem;
